/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ReceiptsInputs */

const en_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipts`)
};

const ar_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإيصالات`)
};

const bn_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রসিদ`)
};

const de_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belege`)
};

const es_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibos`)
};

const fr_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reçus`)
};

const pt_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibos`)
};

const zh_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收据`)
};

const tr_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makbuzlar`)
};

const ru_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чеки`)
};

const pl_svchip_receipts = /** @type {(inputs: Svchip_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paragony`)
};

/**
* | output |
* | --- |
* | "Receipts" |
*
* @param {Svchip_ReceiptsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_receipts = /** @type {((inputs?: Svchip_ReceiptsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ReceiptsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_receipts(inputs)
	if (locale === "bn") return bn_svchip_receipts(inputs)
	if (locale === "de") return de_svchip_receipts(inputs)
	if (locale === "es") return es_svchip_receipts(inputs)
	if (locale === "fr") return fr_svchip_receipts(inputs)
	if (locale === "pt") return pt_svchip_receipts(inputs)
	if (locale === "zh") return zh_svchip_receipts(inputs)
	if (locale === "tr") return tr_svchip_receipts(inputs)
	if (locale === "ru") return ru_svchip_receipts(inputs)
	if (locale === "pl") return pl_svchip_receipts(inputs)
	return en_svchip_receipts(inputs)
});